import script from "./SubscriptionCardDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./SubscriptionCardDetails.vue?vue&type=script&setup=true&lang=js"

import "./SubscriptionCardDetails.vue?vue&type=style&index=0&id=ffe22d18&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ffe22d18"]])

export default __exports__